export const publicaConstants = {
    TRAER_NOTICIAS: 'TRAER_NOTICIAS',
    TRAER_TUTORIALES:'TRAER_TUTORIALES',
    TRAER_SUSCRIPCIONES:'TRAER_SUSCRIPCIONES'

};
